import type {
  ContentRef,
  MetricConfig,
  MetricDetailLevel,
  MetricPresentation,
  MetricResult,
} from '../../types';

export type MetricRendererProps = {
  config: MetricConfig;
  data: MetricResult;
  /** PageConfig item span — `rankedBreakdown` uses `full` for share-table layout. */
  span?: ContentRef['span'];
  /** PageConfig presentation policy — defaults to `full` when omitted. */
  presentation?: MetricPresentation;
  /** Metric id — used by footerLink to open L2 drilldown. */
  metricId?: string;
};

/** Resolve detail level for a placement; unspecified → `full` (backward compatible). */
export const resolveDetailLevel = (presentation?: MetricPresentation): MetricDetailLevel =>
  presentation?.detailLevel ?? 'full';

/** Card title from API `display_name` only — no registry label fallback. */
export const getMetricDisplayName = (data: MetricResult, _config?: MetricConfig): string =>
  (data.display_name && data.display_name.trim()) || '';

export const cardShellSx = (divider: string, paper: string) => ({
  p: 3,
  borderRadius: 2,
  border: `1px solid ${divider}`,
  backgroundColor: paper,
  height: '100%',
  width: '100%',
  display: 'flex',
  flexDirection: 'column' as const,
  position: 'relative' as const,
});
